import React, { Component } from 'react'
import { Row, Col } from 'reactstrap'
import { displayDateFormat, backendDateFormat, fieldDateFormat, float2DecRegx } from '../../../../constants'
import { showCurrencyFormat } from '../../../../utils';
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import { avationPlcInstance, titanInstance } from '../../../../shared_elements/components';
import { jetStreamInstance } from '../../../../lease_management/Leases';

export default class MaintenanceInvoiceItem extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { type, value, invoiceInfo, invoice_item, index, validationArray, isJac, showJCT } = this.props;
    if (type === 'view') {
      return (
        <tr>
          <td>
            <h6 className="para-ui"> {value.invoice_item_type_id.name} </h6>
            {titanInstance && value?.serial_no ? (<p style={{fontSize:'10px'}}>[SN : {value?.serial_no}]</p>):null}
          </td>
          {titanInstance ?
            <td className="para-ui">
              {value.fh_fc_ration || '--'}
            </td> : null}
          {!titanInstance ?
          <td className="invoice-description-block">
            <h6 className="para-ui"> {jetStreamInstance && value?.sale_description ? value.sale_description : value.description}</h6>
          </td>:null}
          <td>
            <h6 className="para-ui">{value.unit_type}{value.unit_type === "Whichever is Greater" && value?.applied_unit_type && avationPlcInstance ? (<><br/>({value?.applied_unit_type?.label})</>):null}</h6>
          </td>
          <td>
            <h6 className="para-ui">
              {value.no_of_unit}
            </h6>
          </td>
          <td>
            <h6 className="para-ui">
              <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                {value.rate_per_unit}
              </NumericLabel>
            </h6>
          </td>
          {
            isJac ?
              null :
              <td>
                {value.tax_rate}
              </td>
          }
          {
            isJac ?
              null :
              <td>
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {parseFloat(value.tax_amount).toFixed(2)}
                </NumericLabel>
              </td>
          }
          <td>
            <h6 className="para-ui">
              {/* <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                {value.sub_total}
              </NumericLabel> */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                  <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                     {value.sub_total ? value.sub_total : 0}
                  </NumericLabel>
                  {value.excess_amount > 0 ?
                    <Tooltip title={`Excess Amount:${invoiceInfo?.currency === 'USD' ? 'US$' : invoiceInfo?.currency === 'EUR' ? '€' : ''}${value.excess_amount}`}>
                      <InfoOutlined style={{ color: '#aeacac' }} fontSize="small" />
                    </Tooltip> : null}
                </div>
            </h6>
          </td>
          {showJCT?
            <>
            <td>
              <h6 className="para-ui">
                  10%
              </h6>
            </td>
            <td>
              <h6 className="para-ui">
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                  {value.sub_total ? value.sub_total / 10 : 0}
                </NumericLabel>
              </h6>
            </td>
          </> : null}
        </tr>
      )
    } else {
      return (
        <tr>
          <td style={{ width: '125px' }}>
            <h6 className="para-ui">
              {invoice_item.invoice_item_type_id.name}
              {titanInstance && invoice_item?.serial_no ? (<p style={{fontSize:'10px'}}>[SN : {invoice_item?.serial_no}]</p>):null}
            </h6>
          </td>
          {titanInstance ?
            <td className="para-ui">
              {invoice_item.fh_fc_ration || '--'}
            </td> : null}
          {!titanInstance ? jetStreamInstance ?
            <td>
              <h6 className="para-ui">{invoice_item.sale_description ? invoice_item.sale_description : invoice_item.description}</h6>
            </td>
            :
            <td className="invoice-description-block">
              <textarea onChange={(e) => this.props.updateInvoiceItemField(e.target.value, 'description', index)}>{invoice_item?.description || ''}</textarea>
            </td>
          : null}
          <td>
            <h6 className="para-ui">{invoice_item.unit_type}{invoice_item.unit_type === "Whichever is Greater" && invoice_item?.applied_unit_type && avationPlcInstance ?  (<><br/>({invoice_item?.applied_unit_type?.label})</>):null}</h6>
          </td>
          <td>
            <input type="text" value={invoice_item.no_of_unit}
              onChange={(e) => float2DecRegx.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'no_of_unit', index, invoice_item.invoice_item_type_id.name, invoice_item.unit_type) : null}
            />
            {validationArray.length > 0 ?
              validationArray[index].no_of_unit == false ?
                <h6 className="error-msg">Please enter valid values</h6> : null : null}
          </td>
          <td>
            <input type="text" value={invoice_item.rate_per_unit}
              onChange={(e) => float2DecRegx.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'rate_per_unit', index): null}
            />
            {validationArray.length > 0 ?
              validationArray[index].rate_per_unit == false ?
                <h6 className="error-msg">Please enter valid values</h6> : null : null}
          </td>
          {
            isJac ?
            null :
          <td style={{ width: '60px' }}>
            <input type="text" value={invoice_item.tax_rate}
              onChange={(e) => float2DecRegx.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'tax_rate', index): null}
            />
            {validationArray.length > 0 ?
              validationArray[index].tax_rate == false ?
                <h6 className="error-msg">Please enter valid value</h6> : null : null}
          </td>}
          {
            isJac ?
              null :
              <td>
                <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>{invoice_item.tax_amount}</NumericLabel>
              </td>}
          <td>
            <input type="text" value={invoice_item.sub_total}
              onChange={(e) =>float2DecRegx.test(e.target.value) ? this.props.updateInvoiceItemField(e.target.value, 'sub_total', index): null}
            />
          </td>
          {
            showJCT ?
              <>
                <td>
                  <h6 className="para-ui">
                      10%
                  </h6>
                </td>
                <td>
                  <h6 className="para-ui">
                    <NumericLabel params={showCurrencyFormat(invoiceInfo.currency)}>
                      {invoice_item.sub_total ? invoice_item.sub_total / 10 : 0}
                    </NumericLabel>
                  </h6>
                </td>
              </>
              : null }
        </tr>
      )
    }
  }
}
